import produce from 'immer';
import * as actions from './actions';
var setField = function (state, payload) {
    return produce(state, function (draftState) {
        var key = payload.key, value = payload.value;
        draftState.fields[key] = value;
    });
};
var resetFields = function (state, payload) {
    return produce(state, function (draftState) {
        draftState.fields = payload;
    });
};
var changeFocus = function (state, payload) {
    return produce(state, function (draftState) {
        var windowId = payload.windowId, widgetId = payload.widgetId;
        draftState.focusedEle = {
            windowId: windowId,
            widgetId: widgetId,
        };
    });
};
var updateFocusedTab = function (state, payload) {
    return produce(state, function (draftState) {
        var buttonId = payload.buttonId;
        draftState.focusedButton = buttonId;
    });
};
var initialState = {
    fields: {},
    focusedEle: {
        windowId: '',
        widgetId: '',
    },
    focusedButton: '',
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    var newState;
    switch (type) {
        case actions.SET_FIELD:
            newState = setField(state, payload);
            break;
        case actions.RESET_STATE:
            newState = resetFields(state, payload);
            break;
        case actions.CHANGE_FOCUS:
            newState = changeFocus(state, payload);
            break;
        case actions.UPDATE_BUTTON_FOCUS:
            newState = updateFocusedTab(state, payload);
            break;
        default:
            newState = state;
    }
    console.group('action ', action.type);
    console.debug('%cprev state', 'color:gray', state);
    console.debug('%caction ', 'color:rgb(0,149,245)', action);
    console.debug('%cnext state', 'color:green', newState);
    console.groupEnd();
    return newState;
};
export default reducer;
//# sourceMappingURL=reducer.js.map